<script setup>
import axios from "axios"
import { ref } from 'vue'
import { CheckBadgeIcon, HeartIcon } from "@heroicons/vue/24/solid";
import { ChatBubbleOvalLeftEllipsisIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const isFavourited = ref(props.item.isFavourite)

const toggleFavourite = () => {
  axios.post(route('stores.favourite', { store: props.item.id }))
    .then(isFavourited.value = !isFavourited.value)
    .catch(err => console.error(err))
}
</script>

<template>
  <div class="bg-white p-2 border border-gray-300 rounded flex gap-2">
    <a :href="item.url">
      <img
        :src="item.image"
        :alt="item.name"
        class="size-24 object-cover"
      >
    </a>
    <div class="flex justify-between flex-grow">
      <div class="my-0.5 space-y-2 flex flex-col justify-between">
        <div>
          <a :href="item.url"
             class="flex items-center gap-1"
          >
            <span class="text-sm font-semibold capitalize text-blue-500 hover:underline hover:text-indigo-500">
              {{ item.name }}
            </span>
            <CheckBadgeIcon v-if="item.is_verified" class="size-5 text-emerald-500" />
          </a>
          <span class="text-sm text-gray-500">{{ item.country }}</span>
        </div>
        <div class="flex gap-2 items-center divide-gray-200 divide-x">
          <span class="text-sm text-gray-500">
            {{ item.open_auctions_count + (item.open_auctions_count === 1 ? ' Product' : ' Products') }}
          </span>
          <a rel="nofollow"
             :href="item.feedback_url"
             class="text-sm text-gray-500 hover:underline hover:text-indigo-500 pl-2"
          >
            {{ __(':count Feedback', { count: item.feedback_count }) }}
          </a>
        </div>
      </div>
      <div class="flex flex-col gap-2 pt-2" v-if="$page.props.auth">
        <a
          class="p-1 border border-gray-300 rounded-md hover:bg-gray-50 group "
          :href="item.contact_url"
        >
          <ChatBubbleOvalLeftEllipsisIcon class="size-5 text-gray-400" />
        </a>
        <div
          rel="nofollow"
          @click="toggleFavourite"
          class="!p-1 border border-gray-300 rounded-md hover:bg-gray-50"
        >
          <HeartIcon class="size-5 " :class="[isFavourited ? 'text-[#DA4F49]' : 'text-gray-400']" />
        </div>
      </div>
    </div>
  </div>
</template>
